import styled from 'styled-components'
import { useContext } from 'react'

import { Globals } from '@h2/globals'

import { Walkthrough } from './walkthrough'
import { Connect } from './connect'
import { MyWork } from './myWork'

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`
const Resources = ({ setOpenModal }) => {
  const { isNavianceElementary } = useContext(Globals)

  return (
    <Wrap>
      <Walkthrough />
      {isNavianceElementary && <MyWork />}
      <Connect setOpenModal={setOpenModal} />
    </Wrap>
  )
}

export { Resources }
